import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  withStateHandlers,
  compose,
  withHandlers,
  lifecycle,
} from 'recompose';
import moment from 'moment';

import config from 'config';
import requestsStatuses from 'modules/common/constants/requestsStatuses';
import { formatPhoneNumber } from 'modules/user/utils/formatPhoneNumber';
import { fetchOrganizations } from '../../actions/fetchOrganizations';
import {
  selectOrganizationToken,
  submitOrganizationSelectionForm,
} from '../../actions/organizationSelection';
import { submitLoginForm } from '../../actions/loginForm';

import LoginForm from './LoginForm';


const mapStateToProps = (state) => ({
  status: state.auth.loginForm.status,
  localErrorCodes: state.auth.loginForm.localErrorCodes,
  apiErrorCodes: state.auth.loginForm.apiErrorCodes,
  reCaptchaSiteKey: state.auth.organizations.reCaptchaSiteKey,
  selectedOrganizationToken: state.auth.organizations.selectedOrganizationToken,
  showReCaptcha: state.auth.organizations.reCaptchaSiteKey && state.auth.loginForm.isLastLoginFailedAttempt,
  pathname: state.router.location.pathname,
});

const mapDispatchToProps = {
  fetchOrganizations,
  selectOrganizationToken,
  submitOrganizationSelectionForm,
  submitLoginForm,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),

  withStateHandlers({ captchaToken: '' }, {
    handleReCaptchaVerifyCallback: () => (captchaToken) => ({ captchaToken }),
  }),

  withHandlers({
    handleFormSubmit: ({ showReCaptcha, captchaToken, submitLoginForm }) => (formData, isExtendedLogin) => {
      document.activeElement.blur();

      if (showReCaptcha && !captchaToken) return;

      const data = { ...formData };
      if (data.phoneNumber) data.phoneNumber = formatPhoneNumber(data.phoneNumber);
      if (data.dateOfBirth) data.dateOfBirth = moment.utc(data.dateOfBirth, 'D/M/YYYY', true).valueOf().toString();

      if (showReCaptcha) {
        return submitLoginForm(data, isExtendedLogin, captchaToken);
      }

      return submitLoginForm(data, isExtendedLogin);
    },
  }),

  lifecycle({
    componentWillMount() {
      const {
        fetchOrganizations,
        selectOrganizationToken,
        submitOrganizationSelectionForm,
        selectedOrganizationToken,
      } = this.props;

      const orgId = Number(config.org_id);

      if (orgId && !selectedOrganizationToken) {
        fetchOrganizations()
          .then(selectOrganizationToken(orgId))
          .then(submitOrganizationSelectionForm());
      }
    },

    componentWillReceiveProps(nextProps) {
      const { captchaToken, handleReCaptchaVerifyCallback } = this.props;
      const { status } = nextProps;
      const recaptchaId = document.getElementById('_grecaptcha.element.id');

      if (status === requestsStatuses.failure && captchaToken && recaptchaId) {
        window.grecaptcha.reset();
        handleReCaptchaVerifyCallback('');
      }

    },
  }),

  injectIntl,
)(LoginForm);
